import React, { useEffect, useState } from "react";
let apiUrl = "https://api.nytimes.com/svc/topstories/v2";
let apiKey = "6Su9mVVtjY2phKvKvPEjFX0O3J70yNBK"; 
let type ="home.json";

const NYTimes = () => {
  const [news, setNews] = useState(null);
  useEffect(() => {
    let api = `${apiUrl}/${type}?api-key=${apiKey}`;
    fetch(api).then(response => response.json()).then(data => {
      setNews(data);
      console.log(data)
    })
  }, []);

  return (
    news && news.results.splice(0,10).map((article, index) => {
      return (
        <div className="article">
          <article key={article.url}>
            <a className="article-title" href={article.url}>{article.title}</a> 
            <p className="article-description" alt={index}>{article.abstract}</p>
          </article>
        </div>
      )
    })
  );
}

  
export default NYTimes;